<template>
  <h5 class="text-center">Nova Medição</h5>
  <div class="mb-4 text-center">
    <div class="form-check form-check-inline form-check-reverse">
      <input
        type="radio"
        class="form-check-input"
        id="typeMeasureT"
        value="T"
        v-model="typeMeasure"
      />
      <label class="form-check-label" for="typeMeasureT">Técnico</label>
    </div>
    <div class="form-check form-check-inline form-check-reverse">
      <input
        type="radio"
        class="form-check-input"
        id="typeMeasureS"
        value="S"
        v-model="typeMeasure"
      />
      <label class="form-check-label" for="typeMeasureS">Supervisor</label>
    </div>
    <div class="form-check form-check-inline form-check-reverse">
      <input
        type="radio"
        class="form-check-input"
        id="typeMeasureX"
        value="X"
        v-model="typeMeasure"
      />
      <label class="form-check-label" for="typeMeasureX">
        Prosseguir Sem Validar
      </label>
    </div>
    <hr />
  </div>
  <div
    v-if="typeMeasure == 'T'"
    class="alert alert-primary border-0 alert-dismissible fade show"
  >
    Você pode consultar a dispensa das certidões utilizando o "Código de
    Prestação de Contas" ou clicar em "Prosseguir Sem Validar" para continuar
    sem a validação.
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="alert"
      title="Fechar"
    />
  </div>
  <div
    v-if="typeMeasure == 'S'"
    class="alert alert-primary border-0 alert-dismissible fade show"
  >
    Você pode consultar a dispensa das certidões utilizando um dos "Código para
    Rateio" ou clicar em "Prosseguir Sem Validar" para continuar sem a
    validação.
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="alert"
      title="Fechar"
    />
  </div>
  <div v-if="typeMeasure == 'T'" class="row g-3">
    <div class="col-md-3 d-flex align-items-center">
      <label class="form-label mb-0">Código de Prestação de Contas:</label>
    </div>
    <div class="col-md-9">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Digite aqui o código de prestação de contas..."
          v-model="ategPcTecId"
        />
        <button
          type="button"
          class="btn btn-secondary rounded-pill ms-2"
          title="Consultar"
          :disabled="disableButton"
          @click="getAtegPcTecInfo"
        >
          <span v-if="disableButton">
            <i class="ph-spinner spinner me-2" />Consultar
          </span>
          <span v-else><i class="ph-magnifying-glass me-2" />Consultar</span>
        </button>
        <button
          type="button"
          class="btn btn-yellow rounded-pill ms-2"
          title="Prosseguir Sem Validar"
          @click="forwardWithoutCertificateValidationAteg"
        >
          Prosseguir Sem Validar
        </button>
      </div>
    </div>
  </div>
  <div v-if="typeMeasure == 'S'" class="row g-3">
    <div class="col-md-3 d-flex align-items-center">
      <label class="form-label mb-0">Código para Rateio:</label>
    </div>
    <div class="col-md-9">
      <div class="input-group">
        <select class="form-select" v-model="selectAtegPcSupNfCodRateio">
          <option value="" disabled>Selecione uma opção</option>
          <option
            :value="ategPcSup.AtegPcSupNfCodRateio"
            v-for="ategPcSup in ategPcSupList"
            :key="ategPcSup.id"
          >
            Cód. p/ Rateio: {{ ategPcSup.AtegPcSupNfCodRateio }} - Projeto ATeG:
            {{ ategPcSup.ProjetoAtegNome }}, Data NF:
            {{ dateTimeRmToDateBR(ategPcSup.AtegPcSupNfData) }}, Valor NF:
            {{ formatToCurrencyBr(ategPcSup.AtegPcSupNfValor) }}
          </option>
        </select>
        <span class="m-2">ou</span>
        <input
          type="text"
          class="form-control"
          placeholder="Digite aqui o código para rateio..."
          v-model="inputAtegPcSupNfCodRateio"
        />
        <button
          type="button"
          class="btn btn-secondary rounded-pill ms-2"
          title="Consultar"
          :disabled="disableButton"
          @click="getAtegPcSupInfo"
        >
          <span v-if="disableButton">
            <i class="ph-spinner spinner me-2" />Consultar
          </span>
          <span v-else><i class="ph-magnifying-glass me-2" />Consultar</span>
        </button>
        <button
          type="button"
          class="btn btn-yellow rounded-pill ms-2"
          title="Prosseguir Sem Validar"
          @click="forwardWithoutCertificateValidationAteg"
        >
          Prosseguir Sem Validar
        </button>
      </div>
    </div>
  </div>
  <div v-if="resultSearch.VALIDA === 'OK'">
    <hr />
    <div class="alert alert-success">
      Este contrato não necessita de validação das certidões locais, clique em
      "Prosseguir" para continuar com as medições.
    </div>
    <h5 class="text-center">Documentos</h5>
    <ul v-for="(document, index) in documents" :key="index">
      <li v-if="document.name.length > 0">
        {{ document.name }}.{{ document.ext }}
        <button
          type="button"
          class="btn badge bg-primary ms-1"
          title="Download"
          @click="downloadBase64File(document)"
        >
          Download
        </button>
      </li>
    </ul>
    <div class="text-end mt-3">
      <button
        type="button"
        class="btn btn-secondary rounded-pill"
        title="Prosseguir"
        @click="forwardWithCertificateValidationAteg"
      >
        Prosseguir
      </button>
    </div>
  </div>
  <div v-if="resultSearch.VALIDA === 'VALIDAR'">
    <hr />
    <div class="alert alert-warning">
      Este contrato necessita de validação das certidões locais, clique em
      "Prosseguir" para que seja validado as certidões.
    </div>
    <div class="text-end">
      <button
        class="btn btn-warning rounded-pill"
        title="Prosseguir"
        @click="forwardWithoutCertificateValidationAteg"
      >
        Prosseguir
      </button>
    </div>
  </div>
</template>

<script>
import { dateTimeRmToDateBR } from '@/utils/date'
import { formatToCurrencyBr } from '@/utils/currency'

export default {
  name: 'ValidateCertificateAteg',

  props: {
    contractId: {
      type: Number,
      required: true,
    },
  },

  emits: ['forwardCertificateValidationAteg'],

  data() {
    return {
      typeMeasure: '',
      ategPcTecId: null,
      ategPcSupList: [],
      ategPcSupNfCodRateio: '',
      selectAtegPcSupNfCodRateio: '',
      inputAtegPcSupNfCodRateio: '',
      resultSearch: {
        VALIDA: null,
        VALIDAMEDICAO: null,
      },
      documents: {
        ategPcTecXmlNF: {
          file: null,
          name: null,
          ext: null,
        },
        ategPcTecPdfNF: {
          file: null,
          name: null,
          ext: null,
        },
        ategPcTecPjCertMuniDoc: {
          file: null,
          name: null,
          ext: null,
        },
        ategPcTecPjCertEstDoc: {
          file: null,
          name: null,
          ext: null,
        },
        ategPcTecPjCertInssDoc: {
          file: null,
          name: null,
          ext: null,
        },
        ategPcTecPjCertFgtsDoc: {
          file: null,
          name: null,
          ext: null,
        },
        ategPcTecPjCertTrabDoc: {
          file: null,
          name: null,
          ext: null,
        },
        ategPcTecPjDeclSimpDoc: {
          file: null,
          name: null,
          ext: null,
        },
      },
      dateTimeRmToDateBR,
      formatToCurrencyBr,
      disableButton: false,
    }
  },

  watch: {
    typeMeasure: {
      handler(newVal, oldVal) {
        if (newVal === 'S') {
          this.getAtegPcSupList()
        }
        if (newVal === 'X') {
          this.forwardWithoutCertificateValidationAteg()
        }
      },
    },
    selectAtegPcSupNfCodRateio: {
      handler(newVal, oldVal) {
        if (newVal !== '') {
          this.inputAtegPcSupNfCodRateio = ''
          this.ategPcSupNfCodRateio = newVal
        }
      },
    },
    inputAtegPcSupNfCodRateio: {
      handler(newVal, oldVal) {
        if (newVal !== '') {
          this.selectAtegPcSupNfCodRateio = ''
          this.ategPcSupNfCodRateio = newVal
        }
      },
    },
  },

  methods: {
    async getAtegPcTecInfo() {
      if (!this.ategPcTecId) {
        this.$root.$refs.notification.warning(
          'Informe o código de prestação de contas.',
        )
        return
      }

      try {
        this.disableButton = true

        this.resultSearch = await this.$store.dispatch('getAtegPcTecInfo', {
          contractId: this.contractId,
          ategPcTecId: this.ategPcTecId,
        })

        if (this.resultSearch === false) {
          this.$root.$refs.notification.warning(
            'Não foram encontrados dados com este código de prestação de contas. Verifique se o código está correto.',
          )
        } else {
          this.resultSearchToDocuments()
        }
        this.disableButton = false
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getAtegPcSupList() {
      try {
        this.ategPcSupList = await this.$store.dispatch(
          'getAtegPcSupList',
          this.contractId,
        )
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getAtegPcSupInfo() {
      if (!this.ategPcSupNfCodRateio) {
        this.$root.$refs.notification.warning('Selecione o código para rateio.')
        return
      }

      try {
        this.disableButton = true

        this.resultSearch = await this.$store.dispatch('getAtegPcSupInfo', {
          contractId: this.contractId,
          ategPcSupNfCodRateio: this.ategPcSupNfCodRateio,
        })

        if (this.resultSearch === false) {
          this.$root.$refs.notification.warning(
            'Não foram encontrados dados com este código para rateio.',
          )
        } else {
          this.resultSearchToDocuments()
        }
        this.disableButton = false
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    resultSearchToDocuments() {
      this.documents = {
        ategPcTecXmlNF: {
          file: this.resultSearch.AtegPcTecXmlNF
            ? this.resultSearch.AtegPcTecXmlNF
            : this.resultSearch.ATEGPCTECXMLNF,
          name: this.resultSearch.AtegPcTecXmlNFArqNome
            ? this.resultSearch.AtegPcTecXmlNFArqNome
            : this.resultSearch.ATEGPCTECXMLNFARQNOME,
          ext: this.resultSearch.AtegPcTecXmlNFArqTipo
            ? this.resultSearch.AtegPcTecXmlNFArqTipo
            : this.resultSearch.ATEGPCTECXMLNFARQTIPO,
        },
        ategPcTecPdfNF: {
          file: this.resultSearch.AtegPcTecPdfNF
            ? this.resultSearch.AtegPcTecPdfNF
            : this.resultSearch.ATEGPCTECPDFNF,
          name: this.resultSearch.AtegPcTecPdfNFArqNome
            ? this.resultSearch.AtegPcTecPdfNFArqNome
            : this.resultSearch.ATEGPCTECPDFNFARQNOME,
          ext: this.resultSearch.AtegPcTecPdfNFArqTipo
            ? this.resultSearch.AtegPcTecPdfNFArqTipo
            : this.resultSearch.ATEGPCTECPDFNFARQTIPO,
        },
        ategPcTecPjCertMuniDoc: {
          file: this.resultSearch.AtegPcTecPjCertMuniDoc
            ? this.resultSearch.AtegPcTecPjCertMuniDoc
            : this.resultSearch.ATEGPCTECPJCERTMUNIDOC,
          name: this.resultSearch.AtegPcTecPjCertMuniDocFn
            ? this.resultSearch.AtegPcTecPjCertMuniDocFn
            : this.resultSearch.ATEGPCTECPJCERTMUNIDOCFN,
          ext: this.resultSearch.AtegPcTecPjCertMuniDocFt
            ? this.resultSearch.AtegPcTecPjCertMuniDocFt
            : this.resultSearch.ATEGPCTECPJCERTMUNIDOCFT,
        },
        ategPcTecPjCertEstDoc: {
          file: this.resultSearch.AtegPcTecPjCertEstDoc
            ? this.resultSearch.AtegPcTecPjCertEstDoc
            : this.resultSearch.ATEGPCTECPJCERTESTDOC,
          name: this.resultSearch.AtegPcTecPjCertEstDocFn
            ? this.resultSearch.AtegPcTecPjCertEstDocFn
            : this.resultSearch.ATEGPCTECPJCERTESTDOCFN,
          ext: this.resultSearch.AtegPcTecPjCertEstDocFt
            ? this.resultSearch.AtegPcTecPjCertEstDocFt
            : this.resultSearch.ATEGPCTECPJCERTESTDOCFT,
        },
        ategPcTecPjCertInssDoc: {
          file: this.resultSearch.AtegPcTecPjCertInssDoc
            ? this.resultSearch.AtegPcTecPjCertInssDoc
            : this.resultSearch.ATEGPCTECPJCERTINSSDOC,
          name: this.resultSearch.AtegPcTecPjCertInssDocFn
            ? this.resultSearch.AtegPcTecPjCertInssDocFn
            : this.resultSearch.ATEGPCTECPJCERTINSSDOCFN,
          ext: this.resultSearch.AtegPcTecPjCertInssDocFt
            ? this.resultSearch.AtegPcTecPjCertInssDocFt
            : this.resultSearch.ATEGPCTECPJCERTINSSDOCFT,
        },
        ategPcTecPjCertFgtsDoc: {
          file: this.resultSearch.AtegPcTecPjCertFgtsDoc
            ? this.resultSearch.AtegPcTecPjCertFgtsDoc
            : this.resultSearch.ATEGPCTECPJCERTFGTSDOC,
          name: this.resultSearch.AtegPcTecPjCertFgtsDocFn
            ? this.resultSearch.AtegPcTecPjCertFgtsDocFn
            : this.resultSearch.ATEGPCTECPJCERTFGTSDOCFN,
          ext: this.resultSearch.AtegPcTecPjCertFgtsDocFt
            ? this.resultSearch.AtegPcTecPjCertFgtsDocFt
            : this.resultSearch.ATEGPCTECPJCERTFGTSDOCFT,
        },
        ategPcTecPjCertTrabDoc: {
          file: this.resultSearch.AtegPcTecPjCertTrabDoc
            ? this.resultSearch.AtegPcTecPjCertTrabDoc
            : this.resultSearch.ATEGPCTECPJCERTTRABDOC,
          name: this.resultSearch.AtegPcTecPjCertTrabDocFn
            ? this.resultSearch.AtegPcTecPjCertTrabDocFn
            : this.resultSearch.ATEGPCTECPJCERTTRABDOCFN,
          ext: this.resultSearch.AtegPcTecPjCertTrabDocFt
            ? this.resultSearch.AtegPcTecPjCertTrabDocFt
            : this.resultSearch.ATEGPCTECPJCERTTRABDOCFT,
        },
        ategPcTecPjDeclSimpDoc: {
          file: this.resultSearch.AtegPcTecPjDeclSimpDoc
            ? this.resultSearch.AtegPcTecPjDeclSimpDoc
            : this.resultSearch.ATEGPCTECPJDECLSIMPDOC,
          name: this.resultSearch.AtegPcTecPjDeclSimpDocFn
            ? this.resultSearch.AtegPcTecPjDeclSimpDocFn
            : this.resultSearch.ATEGPCTECPJDECLSIMPDOCFN,
          ext: this.resultSearch.AtegPcTecPjDeclSimpDocFt
            ? this.resultSearch.AtegPcTecPjDeclSimpDocFt
            : this.resultSearch.ATEGPCTECPJDECLSIMPDOCFT,
        },
      }
    },

    downloadBase64File(file) {
      const base64String = file.file
      const fileName = file.name
      const fileExtension = file.ext

      const binaryData = atob(base64String)
      const byteNumbers = new Array(binaryData.length)

      for (let i = 0; i < binaryData.length; i += 1) {
        byteNumbers[i] = binaryData.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: 'application/octet-stream' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')

      a.href = url
      a.download = `${fileName}.${fileExtension}`
      a.click()

      window.URL.revokeObjectURL(url)
    },

    forwardWithCertificateValidationAteg() {
      this.$emit('forwardCertificateValidationAteg', {
        step: 'UploadXMLFile',
        typeMeasure: this.typeMeasure,
        ategPcTecId:
          this.typeMeasure === 'T'
            ? this.ategPcTecId
            : this.ategPcSupNfCodRateio,
        validateResult: this.resultSearch.VALIDA,
        ategAutoApprove: this.resultSearch.VALIDAMEDICAO,
        ategPcTecXmlNF: this.documents.ategPcTecXmlNF,
        ategPcTecPdfNF: this.documents.ategPcTecPdfNF,
      })
    },

    forwardWithoutCertificateValidationAteg() {
      this.$emit('forwardCertificateValidationAteg', {
        step: 'ValidateCertificateLocal',
        typeMeasure: this.typeMeasure,
        ategPcTecId: null,
        validateResult: false,
        ategAutoApprove: null,
        ategPcTecXmlNF: null,
        ategPcTecPdfNF: null,
      })
    },
  },
}
</script>
